import { bdcRepository } from './Repository'
import { concatenationUrl } from '@/utils/index'

const resource = 'layout'
export default {
  getSliders(customerApiToken = null) {
    const endpoint = `${resource}/sliders`
    const qsParams = {
      customerApiToken: customerApiToken,
    }

    return bdcRepository.get(concatenationUrl`/${endpoint}?${qsParams}`)
  },
}